import { InjectionToken } from '@angular/core';

export interface ApplicationConfig {
  agGridLicense: string;
  sentryDsn: string;
  firebase: {
    apiKey: string;
    authDomain: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
    measurementId: string;
  };
  googleAnalyticsId: string;
}

export const APPLICATION_CONFIG = new InjectionToken<ApplicationConfig>(
  'application.config',
);
